import { useState, useEffect } from "react";
import ShimmerLoader from "../../components/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchfranchisehistory } from "../wallet/walletSlice";
import { selectCurrentUser } from "../auth/authSlice";
import Moment from "moment";
import { format, parseISO } from "date-fns";
import dayjs from "dayjs";
import { Funnel, FileSpreadsheet } from "lucide-react";
import CurFt from "../../components/CurFt";
import Pagination from "../../components/Pagination";
import { BOOKING_STATUS } from "../../utils/constants";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { getbaseURL } from "../../api/axios";

export default function Commissionledger() {
  useDocumentTitle("Commission Ledger Report");
  const dispatch = useDispatch();
  const { franchisehistoryStatus, franchisehistory } = useSelector((state) => state.wallet);
  const perPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [BOOKINGSTATUS, SetBOOKINGSTATUS] = useState(BOOKING_STATUS);
  const [BookingHistory, SetWalletHistory] = useState([]);

  const [totalOrderAmount, settotalOrderAmount] = useState(0);
  const [current_balance, setcurrent_balance] = useState(0);
  const [totalCommissionAmount, settotalCommissionAmount] = useState(0);
  const [totalProfit, settotalProfit] = useState(0);
  const [PlanType, setPlanType] = useState([]);

  const user = useSelector(selectCurrentUser);
  const [showFilters, setShowFilters] = useState(false);
  const [FilterData, setFilterData] = useState({
    type: "current_month",
    ReferenceNo: null,
    TransactionFromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    TransactionToDate: dayjs().endOf("month").format("YYYY-MM-DD"),
    customer_id: user?.UserData?.id,
  });
  const fetchWalletHistory = async () => {
    dispatch(fetchfranchisehistory({ FilterData, perPage, currentPage }));
  };
  useEffect(() => {
    if (user.UserData.user.UserType === 6) {
      fetchWalletHistory();
    }
  }, [FilterData, currentPage]);

  useEffect(() => {
    const data = franchisehistory;

    setPlanType(data?.PlanType || 0);
    settotalOrderAmount(data?.totalOrderAmount || 0);
    settotalCommissionAmount(data?.totalCommissionAmount || 0);
    SetWalletHistory(data?.transactions.data || data);
    setTotalPages(data?.transactions?.last_page);
  }, [franchisehistoryStatus, franchisehistory]);
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleFilterChange = (field, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDateFilter = (type) => {
    let fromDate = null;
    let toDate = null;

    if (type === "current_month") {
      fromDate = dayjs().startOf("month").format("YYYY-MM-DD");
      toDate = dayjs().endOf("month").format("YYYY-MM-DD");
    }

    if (type === "last_month") {
      fromDate = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");

      toDate = dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");
    }

    if (type === "this_year") {
      fromDate = dayjs().startOf("year").format("YYYY-MM-DD");
      toDate = dayjs().format("YYYY-MM-DD");
    }

    setFilterData((prev) => ({
      ...prev,
      TransactionFromDate: fromDate,
      TransactionToDate: toDate,
      type: type,
    }));
  };
  const ExportExcelHandle = () => {
    const queryString = new URLSearchParams(FilterData).toString();
    window.open(getbaseURL() + '/report/franchise-ledger-export?' + queryString + '&accept=download&token=' + user.token, '_blank');
  }

  return (
    <div className="bg-gray-100 text-gray-800 relative min-h-screen">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4 space-y-6">
        <div className="bg-white shadow-md rounded-lg p-4 mt-4">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h3 className="font-semibold">Commission & Discount Report</h3>
            <span className="font-semibold text-blue-500 flex items-center gap-1">
              <div className="relative text-blue-500 text-left">
                TOTAL ORDER
                <br />
                <span className="text-1">
                  <CurFt currency={"INR"} price={totalOrderAmount} />
                </span>
              </div>
            </span>
            <span className="font-semibold flex items-center gap-1">
              <div className="relative text-green-500 text-left">
                COMMISION EARN
                <br />
                <span className="text-1">
                  <CurFt currency={"INR"} price={totalCommissionAmount} />
                </span>
              </div>
            </span>


            <span className="font-semibold text-blue-500 flex items-center gap-1">
              <div className="relative inline-block text-left">
                <button
                  title="Download Ledger"
                  onClick={ExportExcelHandle}
                  className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 ${showFilters ? "bg-blue-600 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"
                    }`}
                >
                  <FileSpreadsheet />
                </button>
              </div>
              <div className="relative inline-block text-left">
                <button
                  onClick={toggleFilters}
                  className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 ${showFilters ? "bg-blue-600 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"
                    }`}
                >
                  <Funnel />
                </button>
              </div>
            </span>
          </div>
        </div>
        {showFilters && (
          <div className="bg-white shadow-md rounded-lg p-6 mt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              {/* First Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Reference Number</label>
                  <input
                    type="text"
                    value={FilterData.ReferenceNo}
                    onChange={(e) => handleFilterChange("ReferenceNo", e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    placeholder="Reference Number"
                  />
                </div>
              </div>

              {/* Second Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking From Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={FilterData.TransactionFromDate ? new Date(FilterData.TransactionFromDate).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("TransactionFromDate", formattedDate);
                      }}
                      max={new Date().toISOString().split("T")[0]}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.TransactionFromDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("TransactionFromDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Third Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking To Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={FilterData.TransactionToDate ? new Date(FilterData.TransactionToDate).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("TransactionToDate", formattedDate);
                      }}
                      // max={new Date().toISOString().split("T")[0]}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.TransactionToDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("TransactionToDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Empty columns for spacing */}
              <div className="space-y-4"></div>
              <div className="space-y-4"></div>

              {/* Close Button in the last column */}
              <div className="space-y-4">
                <div className="pt-6">
                  <button
                    onClick={() => setShowFilters(false)}
                    className="w-full bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                  >
                    Close Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}


        <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">
          {user.UserData.user.UserType === 6 && (
            <div className="overflow-x-auto">
              <div className="inline-flex rounded-base shadow-xs gap-2 mb-2">
                <button
                  onClick={() => handleDateFilter("current_month")}
                  className={`py-1 px-4 border rounded font-semibold transition-all duration-200
          ${FilterData.type === "current_month"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-transparent text-blue-700 border-blue-500 hover:bg-blue-500 hover:text-white"
                    }`}
                >
                  CURRENT MONTH
                </button>

                <button
                  onClick={() => handleDateFilter("last_month")}
                  className={`py-1 px-4 border rounded font-semibold transition-all duration-200
          ${FilterData.type === "last_month"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-transparent text-blue-700 border-blue-500 hover:bg-blue-500 hover:text-white"
                    }`}
                >
                  LAST MONTH
                </button>

                <button
                  onClick={() => handleDateFilter("this_year")}
                  className={`py-1 px-4 border rounded font-semibold transition-all duration-200
          ${FilterData.type === "this_year"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-transparent text-blue-700 border-blue-500 hover:bg-blue-500 hover:text-white"
                    }`}
                >
                  THIS YEAR
                </button>
              </div>


              <table className="min-w-full border  text-sm">
                <thead className="bg-gray-100 text-gray-700">
                  <tr>
                    <th className="px-3 py-2 border text-left">No.</th>
                    <th className="px-3 py-2 border text-left" nowrap="true">
                      Trx Date
                    </th>
                    <th className="px-3 py-2 border text-left" nowrap="true">
                      Reference No
                    </th>
                    <th className="px-3 py-2 border text-left">Product</th>
                    <th className="px-3 py-2 border text-right" nowrap="true">
                      Order Amount
                    </th>
                    <th className="px-3 py-2 border text-right" nowrap="true">
                      Fixed/%
                    </th>
                    <th className="px-3 py-2 border text-right" nowrap="true">
                      Status
                    </th>
                    <th className="px-3 py-2 border text-right" nowrap="true">
                      Commision Earn
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {franchisehistoryStatus === "loading" ? (
                    <>
                      <tr className="border-b">
                        <td className="px-3 py-2 border" colSpan={12}>
                          <ShimmerLoader />
                          <ShimmerLoader />
                          <ShimmerLoader />
                          <ShimmerLoader />
                          <ShimmerLoader />
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {BookingHistory?.length > 0 ? (
                        BookingHistory.map((item, key) => (
                          <tr key={key} className="border-b" >
                            <td className="px-3 py-2 border">{key + 1}</td>
                            <td className="px-3 py-2 border" nowrap="true">
                              {format(parseISO(item.created_at), "dd MMM, yyyy")}
                              <br />
                              {Moment(item.created_at).format("h:mm A")}
                            </td>
                            <td className="px-3 py-2 border" nowrap="true">
                              {item.ReferenceNo}
                            </td>
                            <td className="px-3 py-2 border" nowrap="true">
                              {PlanType[item.PlanType]}
                            </td>
                            <td className="px-3 py-2 border text-right" nowrap="true">
                              <CurFt currency={"INR"} price={item.earning_amount} />
                            </td>
                            <td className="px-3 py-2 border text-right">
                              {parseInt(item.commission_percentage) <= 99 ? (
                                <span>{item.commission_percentage}%</span>
                              ) : (
                                <span>{item.commission_percentage}</span>
                              )}
                            </td>
                            <td className="px-3 py-2 border text-right" nowrap="true">
                              {item.is_settled === 1 ? (
                                <>
                                  <span style={{ color: 'green' }}>{item.is_settled === 1 ? 'SETTLED' : 'OPEN'}</span>
                                  <div>At {format(parseISO(item.settled_at), 'dd/MM/yyyy HH:mm')}</div>
                                  <div>By {item.settledby.fname} {item.settledby.lname}</div>
                                </>
                              ) : (
                                <span style={{ color: 'red' }}>{item.is_settled === 1 ? 'SETTLED' : 'OPEN'}</span>
                              )}
                            </td>
                            <td className="px-3 py-2 border text-right" style={{ color: 'green' }}>
                              <CurFt currency={"INR"} price={item.commission_amount} />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <>
                          <tr className="border-b">
                            <td colSpan={12} className="px-3 py-2 border">
                              No record found
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  )}
                </tbody>
              </table>
              <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
